export interface JwtPayload {
    exp?: number;
    [key: string]: any;
}

export function parseJwt(token: string): JwtPayload | null {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
}

export function isTokenExpired(token: string): boolean {
    const payload = parseJwt(token);
    if (!payload || !payload.exp) {
        // If we can't parse it or it has no expiry, assume it's invalid/expired for safety
        return true;
    }

    // exp is in seconds
    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now;
}
